import nxModule from 'nxModule';

const templateUrl = require('./progressive-charge.template.html');
nxModule.component('progressiveCharge',
  {
    templateUrl: templateUrl,
    bindings: {
      charge: '='
    }
  });